module.exports = __webpack_public_path__ + "img/They-Might-Be-A-Little-Needy.b045695f.jpg";